export default __webpack_public_path__ + "static/media/landscapeHuge.ef2cb46b.jpg";